import React from "react";
import { CircularProgressCustom } from "./common-components/CircularProgressCustom";
import { useQuery } from "@apollo/react-hooks";
import { GET_WARRANT_DOC } from "./../../services/graphql-query";
import { apiUrl } from "./../../services/constants";
import { FaFileDownload } from "react-icons/fa";
import { BsEyeFill } from "react-icons/bs";
import { saveAs } from "file-saver";
import "../../css/app.css";

const Warrant = () => {
    const { loading, error, data } = useQuery(GET_WARRANT_DOC);

    const handleDownload = (url, name) => {
        const pdf_url = apiUrl + url;
        saveAs(pdf_url, name);
    };

    const pdf_view = url => {
        window.open(apiUrl + url, "_blank");
    };

    if (loading) return <CircularProgressCustom />;

    if (error)
        return (
            <>
                <h1>Sorry... We have some error</h1>
            </>
        );

    return (
        <div className="container">
            <div className="resource-header">
                <h2>Warranties / Terms & Conditions</h2>
            </div>
            <div className="warrant-content">
                {data.warrantyDocs?.data?.map((item, key) => {
                    return (
                        <div
                            key={key}
                            className="d-flex flex-column justify-content-center align-items-center"
                        >
                            {item?.attributes?.Warranty_Ten_Years && (
                                <div className="warrant-docs">
                                    <div className="warrant-docs-title">
                                        <label>
                                            {
                                                item.attributes
                                                    ?.Warranty_Ten_Years?.data
                                                    ?.attributes?.name
                                            }
                                        </label>
                                    </div>
                                    <div
                                        className="warrant-docs-icon"
                                        onClick={() =>
                                            handleDownload(
                                                item.attributes
                                                    ?.Warranty_Ten_Years?.data
                                                    ?.attributes?.url,
                                                item.attributes
                                                    ?.Warranty_Ten_Years?.data
                                                    ?.attributes?.name
                                            )
                                        }
                                    >
                                        <FaFileDownload />
                                    </div>
                                    <div
                                        className="warrant-docs-icon"
                                        onClick={() =>
                                            pdf_view(
                                                item.attributes
                                                    ?.Warranty_Ten_Years?.data
                                                    ?.attributes?.url
                                            )
                                        }
                                    >
                                        <BsEyeFill />
                                    </div>
                                </div>
                            )}
                            {item?.attributes?.Warranty_five_years && (
                                <div className="warrant-docs">
                                    <div className="warrant-docs-title">
                                        <label>
                                            {
                                                item.attributes
                                                    ?.Warranty_five_years?.data
                                                    ?.attributes?.name
                                            }
                                        </label>
                                    </div>
                                    <div
                                        className="warrant-docs-icon"
                                        onClick={() =>
                                            handleDownload(
                                                item.attributes
                                                    ?.Warranty_five_years?.data
                                                    ?.attributes?.url,
                                                item.attributes
                                                    ?.Warranty_five_years?.data
                                                    ?.attributes?.name
                                            )
                                        }
                                    >
                                        <FaFileDownload />
                                    </div>
                                    <div
                                        className="warrant-docs-icon"
                                        onClick={() =>
                                            pdf_view(
                                                item.attributes
                                                    ?.Warranty_five_years?.data
                                                    ?.attributes?.url
                                            )
                                        }
                                    >
                                        <BsEyeFill />
                                    </div>
                                </div>
                            )}
                            {item?.attributes?.Terms_and_Conditions && (
                                <div className="warrant-docs">
                                    <div className="warrant-docs-title">
                                        <label>
                                            {
                                                item.attributes
                                                    ?.Terms_and_Conditions?.data
                                                    ?.attributes?.name
                                            }
                                        </label>
                                    </div>
                                    <div
                                        className="warrant-docs-icon"
                                        onClick={() =>
                                            handleDownload(
                                                item.attributes
                                                    ?.Terms_and_Conditions?.data
                                                    ?.attributes?.url,
                                                item.attributes
                                                    ?.Terms_and_Conditions?.data
                                                    ?.attributes?.name
                                            )
                                        }
                                    >
                                        <FaFileDownload />
                                    </div>
                                    <div
                                        className="warrant-docs-icon"
                                        onClick={() =>
                                            pdf_view(
                                                item.attributes
                                                    ?.Terms_and_Conditions?.data
                                                    ?.attributes?.url
                                            )
                                        }
                                    >
                                        <BsEyeFill />
                                    </div>
                                </div>
                            )}
                            {item?.attributes?.Insurance_policy_summary && (
                                <div className="warrant-docs">
                                    <div className="warrant-docs-title">
                                        <label>
                                            {
                                                item.attributes
                                                    ?.Insurance_policy_summary
                                                    ?.data?.attributes?.name
                                            }
                                        </label>
                                    </div>
                                    <div
                                        className="warrant-docs-icon"
                                        onClick={() =>
                                            handleDownload(
                                                item.attributes
                                                    ?.Insurance_policy_summary
                                                    ?.data?.attributes?.url,
                                                item.attributes
                                                    ?.Insurance_policy_summary
                                                    ?.data?.attributes?.name
                                            )
                                        }
                                    >
                                        <FaFileDownload />
                                    </div>
                                    <div
                                        className="warrant-docs-icon"
                                        onClick={() =>
                                            pdf_view(
                                                item.attributes
                                                    ?.Insurance_policy_summary
                                                    ?.data?.attributes?.url
                                            )
                                        }
                                    >
                                        <BsEyeFill />
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Warrant;
